import { input, signal } from '@angular/core';
import * as i0 from "@angular/core";
function AgentLoaderComponent_Conditional_7_For_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 11)(1, "div", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const step_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(step_r3.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(step_r3.description);
} }
function AgentLoaderComponent_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function AgentLoaderComponent_Conditional_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleSteps()); });
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵtext(2, "See Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 9)(5, "ul", 10);
    i0.ɵɵrepeaterCreate(6, AgentLoaderComponent_Conditional_7_For_7_Template, 5, 2, "li", 11, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-expanded", ctx_r1.showSteps());
    i0.ɵɵadvance(4);
    i0.ɵɵclassProp("collapse", !ctx_r1.showSteps())("show", ctx_r1.showSteps());
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.agentSteps());
} }
export class AgentLoaderComponent {
    constructor() {
        this.agentSteps = input([]);
        this.currentLoadingText = input.required();
        this.showSteps = signal(false);
    }
    toggleSteps() {
        this.showSteps.update((x) => !x);
    }
}
AgentLoaderComponent.ɵfac = function AgentLoaderComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentLoaderComponent)(); };
AgentLoaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentLoaderComponent, selectors: [["ycn-agent-loader"]], inputs: { agentSteps: [1, "agentSteps"], currentLoadingText: [1, "currentLoadingText"] }, decls: 8, vars: 2, consts: [[1, "mb-20"], [1, "mb-12", "text-center"], [1, "mt-3", "mb-5"], [1, "loading-steps-title", "public-intro"], [1, "mb-5"], [1, "loader-dots", "loader-dots-large", "loader-dots-jumping", "d-inline-block"], ["role", "button", "aria-controls", "meetingDetails", 1, "btn", "btn-transparent-rounded", 3, "click"], [1, "text-thin"], [1, "collapse-chevron", "align-self-center"], ["id", "meetingDetails"], [1, "list-steps"], [1, "list-steps-item"], [1, "list-steps-title"], [1, "list-steps-description"]], template: function AgentLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelement(6, "div", 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(7, AgentLoaderComponent_Conditional_7_Template, 8, 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.currentLoadingText());
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.agentSteps().length > 0 ? 7 : -1);
    } }, encapsulation: 2, changeDetection: 0 });
